import React from "react"

const Automations = ({ className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M12 4H6.66667C5.19391 4 4 5.19391 4 6.66667V12C4 13.4728 5.19391 14.6667 6.66667 14.6667H12C13.4728 14.6667 14.6667 13.4728 14.6667 12V6.66667C14.6667 5.19391 13.4728 4 12 4Z"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3335 14.667V20.0003C9.3335 20.7076 9.61445 21.3858 10.1145 21.8859C10.6146 22.386 11.2929 22.667 12.0002 22.667H17.3335"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3335 17.333H20.0002C18.5274 17.333 17.3335 18.5269 17.3335 19.9997V25.333C17.3335 26.8058 18.5274 27.9997 20.0002 27.9997H25.3335C26.8063 27.9997 28.0002 26.8058 28.0002 25.333V19.9997C28.0002 18.5269 26.8063 17.333 25.3335 17.333Z"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Automations
